export enum CycleGradeSystemEnum {
  Undefinied,
  At0To150,
  At0To100,
  At1To5,
  Qualitative,
}

export enum CycleAssessmentTypeEnum {
  Undefinied,
  CompetencesOnly,
  CompetencesWithSkillAndAtrributes,
}

export enum NineboxBehaviorEnum {
  Undefined,
  UseExistingConfiguration,
  CreateConfiguration,
}

export enum NineboxChartTypeEnum {
  Undefined,
  CompetencesWithCulturalFit,
  CompetencesWithAxis,
}
